module.exports = __webpack_public_path__ + "media/images/carrusel/lentes-8594488dedf1ab9e769ca0a6d4236849.jpg";